import { connect } from 'react-redux';

import {
  areSegmentsFetching,
  isSegmentDeleting,
  isSegmentUpdating,
} from '../../reducers/analyticsApp';
import CompoundView from '../../components/compound/View';

const mapStateToProps = (state) => ({
  fetching: areSegmentsFetching(state),
  deleting: isSegmentDeleting(state),
  updating: isSegmentUpdating(state),
  executing: false,
});

export default connect(mapStateToProps)(CompoundView);
